module.exports = __webpack_public_path__ + "img/icon_2_8.3c3b11aa.png";